import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import styles from './styles.module.scss';

interface LogoProps {
  size?: 'sm' | 'md' | 'xl';
}

export const Logo: React.FC<LogoProps> = ({ size = 'md' }) => {
  const { isAuthenticated } = useAuth();
  return (
    <NavLink className={`${styles.logo} ${styles[size]}`} to={isAuthenticated ? '/dashboard' : '/'}>
      <span className={styles.highlight}>
        <span>PClash</span>
      </span>
    </NavLink>
  );
};

export default Logo;
